import api from '@/axiosConfig'
import { status } from '../../helpers'

import {
  LOAD_SHOPIFY_ORDERS,
  RESET_SHOPIFY_STATE,
  LOAD_SHOPIFY_FEES
} from '@/state/mutationTypes'
// import router from '@/router'
import i18n from '../../internatinalization/i18n'

const gemnoteAPI = api()

export default {
  async getShopifyOrders(
    { commit, dispatch },
    {
      perPage = 50,
      page = 1,
      filter = 'last_7_days', // default filter
      startDate = null,
      endDate = null,
      search = ''
    }
  ) {
    console.log({ perPage, page, filter, startDate, endDate, search })
    try {
      commit(LOAD_SHOPIFY_ORDERS, status.LOADING)
      let url = `team/shopify?page=${page}&per_page=${perPage}`
      if (search) {
        url += `&search=${search}`
      }
      if (filter) {
        url += `&filter=${filter}`
      } else {
        if (startDate && endDate) {
          url += `&start_date=${startDate}&end_date=${endDate}&filter=date_range`
        }
      }
      const response = await gemnoteAPI.get(url)
      commit('SET_SHOPIFY_ORDERS', response.data)
      commit(LOAD_SHOPIFY_ORDERS, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_SHOPIFY_ORDERS, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('billing.action.get-payment-methods-error')]
          },
          { root: true }
        )
      }
    }
  },
  async getMonthlyFees(
    { commit, dispatch },
    { perPage = 50, page = 1, search = '' }
  ) {
    try {
      commit(LOAD_SHOPIFY_FEES, status.LOADING)
      let url = `team/shopify/monthly_fee?page[number]=${page}&page[size]=${perPage}${
        search ? `&search=${search}` : ''
      }`

      const response = await gemnoteAPI.get(url)
      const data = response.data.data ? response.data.data : response.data
      const links = response.data.links ? response.data.links : response.data
      const meta = response.data.meta ? response.data.meta : response.data

      commit('SET_SHOPIFY_FEES', { data, links, meta })
      commit(LOAD_SHOPIFY_FEES, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_SHOPIFY_ORDERS, status.ERROR)
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('server.no-response')]
          },
          { root: true }
        )
      } else {
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [i18n.t('billing.action.get-payment-methods-error')]
          },
          { root: true }
        )
      }
    }
  },
  async exportShopifyFees({ commit, dispatch }) {
    try {
      await gemnoteAPI.get(`team/shopify/export_monthly_fee`)
      commit('modal/SET_EXPORT_MODAL', true, { root: true })
    } catch (error) {
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('Exporting data failed'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  resetShopifyState({ commit }) {
    commit(RESET_SHOPIFY_STATE)
  }
}
